

export type ObjectMap = { [key: string]: any };

export function getObjectKeysAsString(object: any): string {
  return Object.keys(object).join(', ');
}

export function isNull(root: ObjectMap, path: string) {
  if (!root) return true;

  let steps: string[] = path.split('.');

  let current = root;
  while (steps.length) {
    current = current[steps.shift()!];
    if (current == null) {
      return true;
    }
  }

  return current == null;
}

export function getProp(root: ObjectMap, path: string): any {
  if (!root) return null;

  let result = root;
  let steps: string[] = path.split('.');

  while (steps.length) {
    result = result[steps.shift()!];
    if (result == null) {
      return null;
    }
  }

  return result;
}

export function getPropName(root: ObjectMap, path: string): any {
  if (!root) return null;

  let result = root;
  let steps: string[] = path.split('.');
  let lastStep = '';

  while (steps.length) {
    lastStep = steps.shift()!;
    result = result[lastStep];
    if (result == null) {
      return null;
    }
  }

  return lastStep;
}

export function concatKeys(...args: any[]) {
  let result = '';

  args.forEach((item: any, index: number) => {
    if (index > 0) result += '_';
    result += `${item}`;
  });

  return result;
}

/* eslint-enable no-param-reassign */
